export enum MlbamLoginResponseStatus {
  Login = 1,
  AccountList = 2,
  CreateAccount = 3
}
